var _path, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_47",
    "data-name": "Group 47",
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "_0e5f15e01fcdabf7641d8f3f2fd9f171",
    "data-name": "0e5f15e01fcdabf7641d8f3f2fd9f171",
    d: "M4.393,4.9v8.933A3.482,3.482,0,0,0,7.645,17.31l.229.007h6.147a2.09,2.09,0,0,1-1.97,1.392H7.178A4.177,4.177,0,0,1,3,14.533V6.874A2.09,2.09,0,0,1,4.393,4.9ZM14.836,2a2.089,2.089,0,0,1,2.089,2.089v9.748a2.089,2.089,0,0,1-2.089,2.089H7.874a2.089,2.089,0,0,1-2.089-2.089V4.089A2.089,2.089,0,0,1,7.874,2Zm0,1.393H7.874a.7.7,0,0,0-.7.7v9.748a.7.7,0,0,0,.7.7h6.963a.7.7,0,0,0,.7-.7V4.089A.7.7,0,0,0,14.836,3.393Z",
    transform: "translate(-0.155 -0.548)",
    fill: "#fff"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_13",
    "data-name": "Rectangle 13",
    width: 20,
    height: 20,
    fill: "none"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.15134591f41cd45836535c6b655ca670.svg";
export { ForwardRef as ReactComponent };